import { backOff } from 'exponential-backoff';
import Peer from 'peerjs';
import * as Sentry from '@sentry/browser';

function CreatePeer(logger = console, peerReadyCallback = () => {}) {
  let _lastPeerId = null;
  logger.info('Connecting to signalling server ...');
  const _peer = new Peer(null, {
    debug: 0,
    secure: true,
    host: 'a5f7df9.online-server.cloud',
    port: 9000,
    path: '/myapp',
    config: {
      iceServers: [
        { urls: 'stun:stun.l.google.com:19302' },
        {
          urls: 'turn:a5f7df9.online-server.cloud:3478',
          username: 'custit',
          credential: 'DHOPq4ihl+sad4s',
        },
      ],
    },
  });
  _peer.on('open', () => {
    logger.info('Connected to signalling server');
    if (_peer.id === null) {
      _peer.id = _lastPeerId;
    } else {
      _lastPeerId = _peer.id;
    }

    if (typeof peerReadyCallback === 'function') {
      peerReadyCallback(_peer.id);
    }
  });
  _peer.on('disconnected', () => {
    logger.warn('Connection to signalling server lost');
    Sentry.captureMessage('Connection to signalling server lost');

    backOff(
      () => {
        logger.info('Reconnecting to signalling server ...');
        // Workaround for peer.reconnect deleting previous id
        _peer.id = _lastPeerId;
        _peer._lastServerId = _lastPeerId;
        _peer.reconnect();
      },
      {
        retry: (error, attempts) => {
          logger.warn('Failed to reconnect! (Attempt ' + attempts + ')', error);
          Sentry.setContext('Error', error);
          Sentry.captureMessage(
            'Failed to reconnect! (Attempt ' + attempts + ')'
          );

          return true;
        },
      }
    );
  });
  _peer.on('close', () => {
    logger.error('Connection to signalling server closed');
    Sentry.captureMessage('Connection to signalling server closed');
  });
  _peer.on('error', (err) => {
    Sentry.captureException(err);
  });

  return _peer;
}

export default CreatePeer;
